import {MicrosoftLogo} from './MicrosoftLogo'
import {AzureLogo} from './AzureLogo'
import {VisualStudioCodeLogo} from './VisualStudioCodeLogo'
import {MicrosoftCopilotLogo} from './MicrosoftCopilotLogo'

/**
 * Map of Contentful logo name strings to React SVG components.
 *
 * When adding a new logo, add the component file in this folder
 * and register it here. No other files need to change.
 */
export const logoMap: {[key: string]: () => React.ReactElement} = {
  Microsoft: MicrosoftLogo,
  Azure: AzureLogo,
  'Visual Studio Code': VisualStudioCodeLogo,
  'Microsoft Copilot': MicrosoftCopilotLogo,
}
